<!-- eslint-disable -->
<template lang="pug">
    .timetable-banner
        .timetable-banner__header
            | {{ $i18n.t('dashboard.dashboard_timetable_header') }}
        divider.timetable-banner__divider(:margin="'0 auto'")
        .timetable-banner__body(v-if="!isLoading")
            template(v-if="nearestClasses && nearestClasses.length > 0")
                div(v-for="lesson in nearestClasses")
                    .lesson
                        .lesson__time
                            | {{ lesson.time }}
                        .lesson__date
                            | {{ lesson.date | moment('D MMMM YYYY, dddd')  }}
                        .lesson__course
                            | {{ lesson.course.name }}
                    divider(:margin="'0 auto'")
            .timetable-banner__empty(v-else)
                | {{ $i18n.t('dashboard.dashboard_timetable_noClasses') }}
            divider(:margin="'0 auto'")
        .timetable-banner__footer
            cs-button(color="blue", @click="$router.push({'name': 'timetable'})")
                | {{ $i18n.t('dashboard.dashboard_timetable_goToTimetable') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import TimetableApi from '../../../api/user/timetable';
    import TimetableMixin from '../../../utils/user/timetable';

    export default {
        mixins: [TimetableMixin],
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                TimetableApi.forAllGrades()
                .then((data) => {
                    this.events = _.toArray(data);
                    this.isLoading = false;
                })
                .catch(()=> {
                    this.isLoading = false;
                })
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            })
        },
    }
</script>

<style lang="scss" scoped>
    .timetable-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .timetable-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
    }

    .timetable-banner__body {
        margin: 0 30px;
        font-size: 14px;
        line-height: 20px;
        color: rgba($x-color-black, 0.6);
    }

    .timetable-banner__footer {
        margin: 30px;
    }

    .timetable-banner__task-input {
        padding: 15px 15px 25px 15px;
        margin-bottom: 20px;
    }

    .timetable-banner__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .timetable-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .timetable-banner__empty {
        margin: 20px 0;
        font-size: 16px;
        line-height: 19px;
        color: $x-color-black;
    }

    .timetable-banner__empty-icon {
        color: $hsl-color-gray-74;
        font-size: 30px;
        padding-bottom: 10px;
    }

    .lesson {
        margin: 20px 0;
    }

    .lesson__course {
        font-size: 16px;
        line-height: 19px;
        color: $x-color-black;
        margin-top: 10px;
    }
</style>
